import React, { useEffect } from 'react';
import { useQuery } from 'react-apollo';

import { useAuthService } from '@/contexts/authService';
import { UserQueryPrivate } from '../../state/services/gql/user';
import { trackPageVisit, PAGE_NAME } from '../../utils/tracking';
import { GQLQueryPropType } from '../../proptypes';

import Container from '../../components/Container';
import EmailPrefs from './components';
import LoadingEllipsis from '../../components/LoadingEllipsis';
import Meta from '../../components/Meta';

import { container } from './components/styles.module.css';

function EmailPreferencesPage(props) {
  const authService = useAuthService();
  const { data, loading } = useQuery(UserQueryPrivate, {
    skip: !authService.loggedIn() || __SERVER__,
    variables: {
      id: authService.getUserCookie(),
    },
  });

  useEffect(() => {
    trackPageVisit(PAGE_NAME.EMAIL_PREFERENCES_PAGE);
  }, []);

  if (loading || __SERVER__) {
    return (
      <Container className={container}>
        <LoadingEllipsis htmlTag="h1" />
      </Container>
    );
  }

  if (data?.profile && data?.profile?.emailAddress) {
    return (
      <div>
        <Meta robots="noindex" />
        <EmailPrefs emailAddress={data.profile.emailAddress} />
      </div>
    );
  }

  return (
    <Container className={container}>
      <h1>Something went wrong</h1>
    </Container>
  );
}
export default EmailPreferencesPage;
